import React, { createContext, useContext, useEffect, useState } from 'react';
import { subscribeToForegroundMessages } from '../services/notificationService';

export interface InAppNotification {
  id: number;
  title: string;
  body: string;
  time: Date;
}

interface NotificationContextValue {
  notifications: InAppNotification[];
  unreadCount: number;
  clearAll: () => void;
  markRead: () => void;
}

const NotificationContext = createContext<NotificationContextValue>({
  notifications: [],
  unreadCount: 0,
  clearAll: () => {},
  markRead: () => {},
});

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<InAppNotification[]>([]);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const unsub = subscribeToForegroundMessages((title, body) => {
      setNotifications(prev => [{ id: Date.now(), title, body, time: new Date() }, ...prev.slice(0, 19)]);
      setUnreadCount(c => c + 1);
    });
    return unsub;
  }, []);

  const clearAll = () => setNotifications([]);
  const markRead = () => setUnreadCount(0);

  return (
    <NotificationContext.Provider value={{ notifications, unreadCount, clearAll, markRead }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
